import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import { Button, Form, Row, Col, FormGroup, Input, CustomInput, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import env from '../../configs/config';
import Section from '../../components/common/Section';
import SimpleReactValidator from 'simple-react-validator';
import LoginWithMS from './LoginWithMS';
import LoadingOverlay from 'react-loading-overlay';
import $ from 'jquery';
import identityService from '../../services/identityService';
import LocalStorageStore from '../../apiStores/application/localStorageStore';

const ALLOWED_ROLES = ['admin', 'superadmin'];

class Login extends Component {
  constructor(props) {
    super();
    this.state = {
      _loginMethod: 'email', // 'email' | 'phone'
      _username: '',
      _phoneNumber: '',
      _password: '',
      _mfaCode: '',
      _requiresMfa: false,
      _mfaUserId: '',
      _mfaMessage: '',
      _mfaMethod: 'email', // 'email' | 'phone'
      _debugOtp: '',
      _resendCountdown: 0,
      _resendTimer: null,
      _remember: false,
      _showPasskeyPage: false,
      _passkeyEmail: '',
      // Forgot password
      _showForgotPassword: false,
      _forgotStep: 1,
      _forgotEmail: '',
      _forgotPhone: '',
      _forgotCode: '',
      _forgotToken: '',
      _forgotNewPassword: '',
      _forgotConfirmPassword: '',
      _forgotLoading: false,
      _showNewPassword: false,
      // Application selection
      _availableApplications: [],
      _showApplicationModal: false,
      _selectedApplicationId: '',
      _tempMicrosoftAuthResponse: null, // Temporary Microsoft auth response before app selection
    };
    this.validator = new SimpleReactValidator();
  }

  componentWillUnmount() {
    if (this.state._resendTimer) clearInterval(this.state._resendTimer);
  }

  startResendCountdown = (seconds = 60) => {
    if (this.state._resendTimer) clearInterval(this.state._resendTimer);
    this.setState({ _resendCountdown: seconds });
    const timer = setInterval(() => {
      this.setState((prev) => {
        if (prev._resendCountdown <= 1) {
          clearInterval(prev._resendTimer);
          return { _resendCountdown: 0, _resendTimer: null };
        }
        return { _resendCountdown: prev._resendCountdown - 1 };
      });
    }, 1000);
    this.setState({ _resendTimer: timer });
  };

  componentDidMount = () => {
    const { history } = this.props;
    // Don't redirect if we're waiting for application selection
    if (this.props.applicationStore.isLoggedIn() && !this.state._showApplicationModal) {
      history.push({ pathname: '/welcome' });
    }
  };

  completeLogin = async () => {
    const { history } = this.props;
    $(document).trigger('user-logged-in');
    setTimeout(() => {
      history.push({ pathname: '/welcome' });
    }, 1000);
  };

  resetMfaState = () => {
    if (this.state._resendTimer) clearInterval(this.state._resendTimer);
    this.setState({
      _requiresMfa: false,
      _mfaUserId: '',
      _mfaCode: '',
      _mfaMessage: '',
      _mfaMethod: 'email',
      _debugOtp: '',
      _resendCountdown: 0,
      _resendTimer: null,
    });
  };

  openPasskeyPage = () => {
    this.setState({
      _showPasskeyPage: true,
      _passkeyEmail: this.state._username,
    });
  };

  closePasskeyPage = () => {
    this.setState({
      _showPasskeyPage: false,
      _passkeyEmail: '',
    });
  };

  parseApplicationsFromToken = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.applications) {
        const apps = typeof payload.applications === 'string' ? JSON.parse(payload.applications) : payload.applications;
        console.warn(apps, 'app')
        console.warn(token, 'token')
        return apps.map(app => ({
          ApplicationGuid: app.ApplicationGuid || app.ApplicationId,
          ApplicationName: app.ApplicationName,
        }));
      }
      if (payload.user) {
        const user = typeof payload.user === 'string' ? JSON.parse(payload.user) : payload.user;
        if (user.Instances && Array.isArray(user.Instances)) {
          return user.Instances.map(i => ({
            ApplicationGuid: i.AppKey,
            ApplicationName: i.Name,
          }));
        }
      }
    } catch (e) { }
    return [];
  };

  showApplicationSelectionOrComplete = (authResponse) => {
    const token = authResponse?.token || authResponse?.Token;
    const applications = token ? this.parseApplicationsFromToken(token) : [];
    console.log('showApplicationSelectionOrComplete - Applications:', applications);
    console.log('showApplicationSelectionOrComplete - Token:', token);

    if (applications.length === 0) {
      this.props.applicationStore.logout();
      toast.error('No applications are available for your account. Please contact support.', 8000);
      return;
    }

    // Always show the modal — user must explicitly select an application
    this.setState({
      _availableApplications: applications,
      _showApplicationModal: true,
      _selectedApplicationId: applications.length === 1 ? applications[0].ApplicationGuid : '',
      _tempMicrosoftAuthResponse: authResponse, // Store temporary auth response for later use
    });
  };

  handleApplicationConfirm = async () => {
    const { _selectedApplicationId, _tempMicrosoftAuthResponse } = this.state;
    if (!_selectedApplicationId) return;

    this.props.applicationStore.loading = true;
    try {
      // If this is from Microsoft login, save the temporary token to localStorage first
      if (_tempMicrosoftAuthResponse) {
        LocalStorageStore.saveToken(_tempMicrosoftAuthResponse);
      }

      await this.props.applicationStore.reloginWithApplication(_selectedApplicationId);
      this.setState({ 
        _showApplicationModal: false, 
        _availableApplications: [], 
        _selectedApplicationId: '',
        _tempMicrosoftAuthResponse: null,
      });
      this.props.applicationStore.loading = false;
      toast.success('Signed in successfully.', 5);
      this.completeLogin();
    } catch (error) {
      this.props.applicationStore.loading = false;
      toast.error(error.message || 'Failed to connect to the selected application. Please try again.', 5);
    }
  };

  handleApplicationModalClose = () => {
    this.props.applicationStore.logout();
    this.setState({ 
      _showApplicationModal: false, 
      _availableApplications: [], 
      _selectedApplicationId: '',
      _tempMicrosoftAuthResponse: null,
    });
    toast.info('You must select an application to continue. Please sign in again.', 5);
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    // ── OTP verification step ─────────────────────────────────────────────────
    if (this.state._requiresMfa) {
      if (!this.state._mfaCode.trim()) {
        toast.error('Enter the verification code.', 5);
        return;
      }

      if (!/^\d{6}$/.test(this.state._mfaCode.trim())) {
        toast.error('Enter the 6-digit verification code.', 5);
        return;
      }

      this.props.applicationStore.loading = true;
      try {
        const verifyFn = this.state._mfaMethod === 'phone'
          ? this.props.applicationStore.verifyPhoneIdentityMfa
          : this.props.applicationStore.verifyIdentityMfa;

        const response = await verifyFn(this.state._mfaUserId, this.state._mfaCode.trim());
        await this.props.applicationStore.completeIdentityLogin(response, this.state._remember);

        // Role check
        if (!this.props.applicationStore.checkRoleAccess()) {
          this.props.applicationStore.logout();
          this.props.applicationStore.loading = false;
          toast.error('Access denied. Only Admin and SuperAdmin roles are authorized.', 8000);
          return;
        }

        toast.success('Signed in successfully.', 5);
        this.props.applicationStore.loading = false;
        this.showApplicationSelectionOrComplete(response);
      } catch (error) {
        this.props.applicationStore.loading = false;
        toast.error(error.message || 'Unable to verify the code. Please try again.', 5);
      }
      return;
    }

    // ── Phone login (passwordless OTP) ────────────────────────────────────────
    if (this.state._loginMethod === 'phone') {
      const phone = this.state._phoneNumber.trim();
      if (!phone) {
        toast.error('Enter your phone number.', 5);
        return;
      }

      this.props.applicationStore.loading = true;
      try {
        const response = await this.props.applicationStore.loginWithPhone(phone);
        this.setState({
          _requiresMfa: true,
          _mfaMethod: 'phone',
          _mfaUserId: response?.userId || '',
          _mfaMessage: response?.message || 'Enter the OTP sent to your phone.',
          _debugOtp: response?.debugOtp || '',
          _mfaCode: '',
        });
        this.startResendCountdown(60);
        this.props.applicationStore.loading = false;
        toast.info('OTP sent to your phone number.', 5);
      } catch (error) {
        this.props.applicationStore.loading = false;
        toast.error(error.message || 'Failed to send OTP. Please try again.', 5);
      }
      return;
    }

    // ── Email + password login ────────────────────────────────────────────────
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }

    this.props.applicationStore.loading = true;
    try {
      const response = await this.props.applicationStore.loginWithIdentity(
        this.state._username,
        this.state._password,
        this.state._remember,
      );

      if (response?.requiresMfa) {
        this.setState({
          _requiresMfa: true,
          _mfaMethod: 'email',
          _mfaUserId: response.userId,
          _mfaMessage: response.message || 'Enter the verification code sent to you.',
          _debugOtp: response.debugOtp || '',
          _mfaCode: '',
        });
        this.startResendCountdown(60);
        this.props.applicationStore.loading = false;
        toast.info('Verification code required to complete sign in.', 5);
        return;
      }

      await this.props.applicationStore.completeIdentityLogin(response, this.state._remember);

      // Role check
      if (!this.props.applicationStore.checkRoleAccess()) {
        this.props.applicationStore.logout();
        this.props.applicationStore.loading = false;
        toast.error('Access denied. Only Admin and SuperAdmin roles are authorized.', 8000);
        return;
      }

      toast.success('Signed in successfully.', 5);
      this.props.applicationStore.loading = false;
      this.showApplicationSelectionOrComplete(response);
    } catch (error) {
      this.props.applicationStore.loading = false;
      toast.error(error.message || 'Error occured. Please try again.', 5);
    }
  };

  handlePasskeyLogin = async () => {
    const email = (this.state._passkeyEmail || '').trim();
    if (!email || !/.+@.+\..+/.test(email)) {
      toast.error('Enter a valid email address to use passkey sign in.', 5);
      return;
    }

    this.props.applicationStore.loading = true;
    try {
      const response = await this.props.applicationStore.loginWithPasskey(email);
      await this.props.applicationStore.completeIdentityLogin(response, true);

      // Role check
      if (!this.props.applicationStore.checkRoleAccess()) {
        this.props.applicationStore.logout();
        this.props.applicationStore.loading = false;
        toast.error('Access denied. Only Admin and SuperAdmin roles are authorized.', 8000);
        return;
      }

      toast.success('Signed in successfully.', 5);
      this.setState({ _showPasskeyPage: false, _passkeyEmail: '' });
      this.props.applicationStore.loading = false;
      this.showApplicationSelectionOrComplete(response);
    } catch (error) {
      this.props.applicationStore.loading = false;
      toast.error(error.message || 'Passkey sign in failed. Please try again.', 5);
    }
  };

  handleResendCode = async () => {
    if (!this.state._mfaUserId) return;
    if (this.state._resendCountdown > 0) {
      toast.info(`Please wait ${this.state._resendCountdown}s before resending.`, 5);
      return;
    }

    this.props.applicationStore.loading = true;
    try {
      await this.props.applicationStore.resendIdentityMfa(this.state._mfaUserId);
      this.setState({ _mfaCode: '', _debugOtp: '' });
      this.startResendCountdown(60);
      toast.success('Verification code sent.', 5);
    } catch (error) {
      toast.error(error.message || 'Unable to resend the verification code.', 5);
    } finally {
      this.props.applicationStore.loading = false;
    }
  };

  // ─── Forgot Password ──────────────────────────────────────────────────────

  openForgotPassword = () => {
    this.setState({
      _showForgotPassword: true,
      _forgotStep: 1,
      _forgotEmail: this.state._loginMethod === 'email' ? (this.state._username || '') : '',
      _forgotPhone: this.state._loginMethod === 'phone' ? (this.state._phoneNumber || '') : '',
      _forgotCode: '',
      _forgotToken: '',
      _forgotNewPassword: '',
      _forgotConfirmPassword: '',
    });
  };

  closeForgotPassword = () => {
    this.setState({ _showForgotPassword: false, _forgotStep: 1 });
  };

  handleForgotStep1 = async () => {
    const email = this.state._forgotEmail.trim();
    const phone = this.state._forgotPhone.trim();
    const isPhone = this.state._loginMethod === 'phone';

    if (isPhone) {
      if (!phone) {
        toast.error('Enter your phone number.', 5);
        return;
      }
    } else {
      if (!email || !/.+@.+\..+/.test(email)) {
        toast.error('Enter a valid email address.', 5);
        return;
      }
    }

    this.setState({ _forgotLoading: true });
    try {
      const payload = isPhone ? { phoneNumber: phone } : { email };
      await identityService.requestPasswordReset(payload);
      toast.success(`Verification code sent to your ${isPhone ? 'phone' : 'email'}.`, 5);
      this.setState({ _forgotStep: 2 });
    } catch (err) {
      toast.error(err?.message || 'Failed to send reset code. Please try again.', 5);
    } finally {
      this.setState({ _forgotLoading: false });
    }
  };

  handleForgotStep2 = async () => {
    const code = this.state._forgotCode.trim();
    if (!code || code.length < 4) {
      toast.error('Enter the verification code.', 5);
      return;
    }
    const isPhone = this.state._loginMethod === 'phone';
    this.setState({ _forgotLoading: true });
    try {
      const payload = isPhone
        ? { phoneNumber: this.state._forgotPhone.trim(), code }
        : { email: this.state._forgotEmail.trim(), code };
      const result = await identityService.verifyPasswordResetCode(payload);
      const token = result?.token || result?.resetToken || result;
      this.setState({ _forgotStep: 3, _forgotToken: typeof token === 'string' ? token : '' });
      toast.success('Code verified. Set your new password.', 5);
    } catch (err) {
      toast.error(err?.message || 'Invalid code. Please try again.', 5);
    } finally {
      this.setState({ _forgotLoading: false });
    }
  };

  handleForgotStep3 = async () => {
    const { _forgotNewPassword, _forgotConfirmPassword, _forgotEmail, _forgotPhone, _forgotToken } = this.state;
    if (_forgotNewPassword.length < 6) return toast.error('Password must be at least 6 characters.', 5);
    if (_forgotNewPassword !== _forgotConfirmPassword) return toast.error('Passwords do not match.', 5);

    const isPhone = this.state._loginMethod === 'phone';
    this.setState({ _forgotLoading: true });
    try {
      const payload = {
        token: _forgotToken,
        newPassword: _forgotNewPassword,
        confirmPassword: _forgotConfirmPassword,
        ...(isPhone ? { phoneNumber: _forgotPhone.trim() } : { email: _forgotEmail.trim() }),
      };
      await identityService.completePasswordReset(payload);
      toast.success('Password reset successfully! Please sign in.', 5);
      this.setState({ _showForgotPassword: false, _forgotStep: 1, _password: '' });
    } catch (err) {
      toast.error(err?.message || 'Failed to reset password. Please try again.', 5);
    } finally {
      this.setState({ _forgotLoading: false });
    }
  };

  renderForgotPassword = () => {
    const { _forgotStep, _forgotEmail, _forgotPhone, _forgotCode, _forgotNewPassword, _forgotConfirmPassword,
      _forgotLoading, _showNewPassword } = this.state;
    const isPhone = this.state._loginMethod === 'phone';
    const stepTitles = ['', 'Forgot Password', 'Verify Code', 'New Password'];
    const stepDescs = ['',
      `Enter your ${isPhone ? 'phone number' : 'email'} to receive a verification code.`,
      `Enter the code sent to your ${isPhone ? 'phone' : 'email'}.`,
      'Create a new password for your account.',
    ];
    const stepIcons = ['', isPhone ? 'fa-mobile-alt' : 'fa-envelope', 'fa-shield-alt', 'fa-key'];

    return (
      <div>
        {/* Step indicator */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '20px' }}>
          {[1, 2, 3].map((s) => (
            <div key={s} style={{
              width: s === _forgotStep ? '32px' : '10px', height: '10px',
              borderRadius: '5px', transition: 'all 0.3s',
              backgroundColor: s <= _forgotStep ? '#EB2026' : '#e5e7eb',
            }} />
          ))}
        </div>

        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '50%', margin: '0 auto 12px',
            backgroundColor: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <i className={`fas ${stepIcons[_forgotStep]}`}
              style={{ fontSize: '22px', color: '#EB2026' }}></i>
          </div>
          <h5 style={{ fontWeight: 700, marginBottom: '4px' }}>{stepTitles[_forgotStep]}</h5>
          <p style={{ fontSize: '13px', color: '#9ca3af', margin: 0 }}>{stepDescs[_forgotStep]}</p>
        </div>

        <Form onSubmit={(e) => { e.preventDefault(); }}>
          {_forgotStep === 1 && (
            <>
              <FormGroup>
                {isPhone ? (
                  <Input style={{ height: '44px', borderRadius: '10px' }} placeholder="Enter your phone number"
                    value={_forgotPhone} onChange={({ target }) => this.setState({ _forgotPhone: target.value })}
                    type="tel" autoFocus />
                ) : (
                  <Input style={{ height: '44px', borderRadius: '10px' }} placeholder="Enter your email"
                    value={_forgotEmail} onChange={({ target }) => this.setState({ _forgotEmail: target.value })}
                    type="email" autoFocus />
                )}
              </FormGroup>
              <Button style={{ backgroundColor: '#EB2026', border: 'none', borderRadius: '10px' }}
                block className="py-2" onClick={this.handleForgotStep1} disabled={_forgotLoading}>
                {_forgotLoading ? 'Sending...' : 'Send Verification Code'}
              </Button>
            </>
          )}

          {_forgotStep === 2 && (
            <>
              <FormGroup>
                <Input style={{ height: '44px', borderRadius: '10px', backgroundColor: '#f9fafb' }}
                  value={isPhone ? _forgotPhone : _forgotEmail} readOnly disabled />
              </FormGroup>
              <FormGroup>
                <Input style={{ height: '44px', borderRadius: '10px', textAlign: 'center', fontSize: '18px', letterSpacing: '8px' }}
                  placeholder="000000" value={_forgotCode} maxLength="6" inputMode="numeric" autoFocus
                  onChange={({ target }) => this.setState({ _forgotCode: (target.value || '').replace(/\D/g, '').slice(0, 6) })} />
              </FormGroup>
              <Button style={{ backgroundColor: '#EB2026', border: 'none', borderRadius: '10px' }}
                block className="py-2" onClick={this.handleForgotStep2} disabled={_forgotLoading}>
                {_forgotLoading ? 'Verifying...' : 'Verify Code'}
              </Button>
              <Button color="link" block className="mt-2" style={{ fontSize: '13px' }}
                onClick={this.handleForgotStep1} disabled={_forgotLoading}>
                Resend code
              </Button>
            </>
          )}

          {_forgotStep === 3 && (
            <>
              <FormGroup>
                <div style={{ position: 'relative' }}>
                  <Input style={{ height: '44px', borderRadius: '10px' }} placeholder="New password"
                    type={_showNewPassword ? 'text' : 'password'} value={_forgotNewPassword} autoFocus
                    onChange={({ target }) => this.setState({ _forgotNewPassword: target.value })} />
                  <button type="button" onClick={() => this.setState({ _showNewPassword: !_showNewPassword })}
                    style={{
                      position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                      border: 'none', background: 'none', color: '#9ca3af', cursor: 'pointer', outline: 'none', boxShadow: 'none'
                    }}>
                    <i className={_showNewPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                  </button>
                </div>
              </FormGroup>
              <FormGroup>
                <Input style={{ height: '44px', borderRadius: '10px' }} placeholder="Confirm new password"
                  type="password" value={_forgotConfirmPassword}
                  onChange={({ target }) => this.setState({ _forgotConfirmPassword: target.value })}
                  valid={_forgotConfirmPassword && _forgotNewPassword === _forgotConfirmPassword}
                  invalid={_forgotConfirmPassword && _forgotNewPassword !== _forgotConfirmPassword} />
              </FormGroup>
              <Button style={{ backgroundColor: '#EB2026', border: 'none', borderRadius: '10px' }}
                block className="py-2" onClick={this.handleForgotStep3} disabled={_forgotLoading}>
                {_forgotLoading ? 'Resetting...' : 'Reset Password'}
              </Button>
            </>
          )}

          <Button color="link" block className="mt-2" style={{ color: '#6b7280', fontSize: '13px' }}
            onClick={this.closeForgotPassword}>
            <i className="fas fa-arrow-left mr-1"></i> Back to login
          </Button>
        </Form>
      </div>
    );
  };

  render() {
    return (
      <Section className="py-0">
        <Row className="flex-center min-vh-100 py-6">
          <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
            <LoadingOverlay active={this.props.applicationStore.loading} spinner>
              <Card>
                <CardBody className="fs--1 font-weight-normal p-5">
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src="logo-v-148x142.png"
                      style={{ backgroundColor: 'black', height: '80px', marginBottom: '10px' }}
                      className="resize d-flex justify-content-center"
                      alt="vizybility"
                    />
                  </div>
                  <Fragment>
                    <div className="d-flex justify-content-center pb-3">
                      <h5 className="pt-5">
                        {this.state._showForgotPassword ? '' : this.state._showPasskeyPage ? 'PASSKEY SIGN IN' : 'LOGIN TO YOUR ACCOUNT'}
                      </h5>
                    </div>
                    {this.state._showForgotPassword ? (
                      this.renderForgotPassword()
                    ) : this.state._showPasskeyPage ? (
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          this.handlePasskeyLogin();
                        }}
                      >
                        <FormGroup>
                          <Input
                            style={{ height: '40px' }}
                            placeholder="Enter your email"
                            value={this.state._passkeyEmail}
                            onChange={({ target }) => this.setState({ _passkeyEmail: target.value })}
                            type="email"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Button color="secondary" block type="submit" disabled={!this.state._passkeyEmail}>
                            Login with passkey
                          </Button>
                        </FormGroup>
                        <FormGroup>
                          <Button color="link" type="button" block onClick={this.closePasskeyPage}>
                            Back to login
                          </Button>
                        </FormGroup>
                      </Form>
                    ) : (
                      <Form onSubmit={this.handleSubmit}>
                        {this.state._requiresMfa ? (
                          /* ── OTP / MFA verification step ── */
                          <>
                            <FormGroup>
                              <Input
                                style={{ height: '40px', backgroundColor: '#f8f9fa', color: '#6c757d' }}
                                value={this.state._mfaMethod === 'phone' ? this.state._phoneNumber : this.state._username}
                                type="text"
                                readOnly
                                disabled
                              />
                            </FormGroup>
                            <FormGroup>
                              <Input
                                style={{ height: '44px', borderRadius: '10px', textAlign: 'center', fontSize: '20px', letterSpacing: '10px' }}
                                placeholder="000000"
                                value={this.state._mfaCode}
                                onChange={({ target }) =>
                                  this.setState({ _mfaCode: (target.value || '').replace(/\D/g, '').slice(0, 6) })
                                }
                                type="text"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                maxLength="6"
                                autoFocus
                              />
                              <small className="text-muted d-block mt-2">
                                {this.state._mfaMessage || 'Enter the 6-digit verification code sent to you.'}
                              </small>
                              {this.state._debugOtp && (
                                <small className="d-block mt-1" style={{ color: '#EB2026', fontWeight: 600 }}>
                                  Test OTP: {this.state._debugOtp}
                                </small>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Button
                                style={{ backgroundColor: '#EB2026', border: 'none', borderRadius: '10px' }}
                                block
                                className="mt-3 py-2"
                                disabled={this.state._mfaCode.length !== 6}
                              >
                                Verify Code
                              </Button>
                            </FormGroup>
                            <FormGroup>
                              {this.state._resendCountdown > 0 ? (
                                <small className="d-block text-center text-muted">
                                  Resend in {this.state._resendCountdown}s
                                </small>
                              ) : (
                                <Button color="link" type="button" block onClick={this.handleResendCode}>
                                  Resend verification code
                                </Button>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Button color="secondary" outline block type="button" onClick={this.resetMfaState}>
                                Back to login
                              </Button>
                            </FormGroup>
                          </>
                        ) : (
                          /* ── Credentials step ── */
                          <>
                            {/* Email / Phone tab switcher */}
                            <div style={{ display: 'flex', marginBottom: '20px', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                              {[
                                { id: 'email', label: 'Email', icon: 'fa-envelope' },
                                { id: 'phone', label: 'Phone', icon: 'fa-mobile-alt' },
                              ].map((method, idx) => {
                                const isActive = this.state._loginMethod === method.id;
                                const isFirst = idx === 0;
                                const isLast = idx === 1;
                                return (
                                  <button
                                    key={method.id}
                                    type="button"
                                    onClick={() => this.setState({ _loginMethod: method.id })}
                                    style={{
                                      flex: 1, padding: '10px 0', cursor: 'pointer',
                                      fontWeight: 600, fontSize: '13px', transition: 'background-color 0.2s, color 0.2s',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                                      border: 'none',
                                      borderLeft: isLast ? '1px solid #e5e7eb' : 'none',
                                      borderRadius: isFirst ? '7px 0 0 7px' : '0 7px 7px 0',
                                      backgroundColor: isActive ? '#EB2026' : '#fff',
                                      color: isActive ? '#fff' : '#6b7280',
                                    }}
                                  >
                                    <i className={`fas ${method.icon}`} style={{ fontSize: '14px', lineHeight: 1, marginBottom: '2px' }}></i>
                                    {method.label}
                                  </button>
                                );
                              })}
                            </div>

                            {this.state._loginMethod === 'email' ? (
                              <>
                                <FormGroup>
                                  <Input
                                    style={{ height: '40px' }}
                                    placeholder="Email address"
                                    value={this.state._username}
                                    onChange={({ target }) => this.setState({ _username: target.value })}
                                    type="text"
                                  />
                                  {this.validator.message('user name', this.state._username, 'required|email', {
                                    className: 'text-danger',
                                  })}
                                </FormGroup>
                                <FormGroup>
                                  <Input
                                    style={{ height: '40px' }}
                                    placeholder="Password"
                                    value={this.state._password}
                                    onChange={({ target }) => this.setState({ _password: target.value })}
                                    type="password"
                                  />
                                  {this.validator.message('password', this.state._password, 'required', {
                                    className: 'text-danger',
                                  })}
                                </FormGroup>
                                <Row className="justify-content-between align-items-center">
                                  <Col xs="auto">
                                    <CustomInput
                                      id="customCheckRemember"
                                      label="Remember me"
                                      checked={this.state._remember}
                                      onChange={({ target }) => this.setState({ _remember: target.checked })}
                                      type="checkbox"
                                      className="custom-checkbox-red"
                                    />
                                  </Col>
                                  <Col xs="auto">
                                    <Button color="link" type="button" size="sm"
                                      style={{ fontSize: '13px', color: '#EB2026', padding: 0, fontWeight: 500 }}
                                      onClick={this.openForgotPassword}>
                                      Forgot Password?
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                <FormGroup>
                                  <Input
                                    style={{ height: '40px' }}
                                    placeholder="Phone number (e.g. 555 000 0000)"
                                    value={this.state._phoneNumber}
                                    onChange={({ target }) => this.setState({ _phoneNumber: target.value })}
                                    type="tel"
                                    autoFocus
                                  />
                                </FormGroup>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 12px', backgroundColor: '#eff6ff', borderRadius: '8px', marginBottom: '12px', fontSize: '12px', color: '#3b82f6' }}>
                                  <i className="fas fa-info-circle" style={{ fontSize: '13px', flexShrink: 0 }}></i>
                                  We'll send a one-time code to your phone. No password needed.
                                </div>
                              </>
                            )}

                            <FormGroup>
                              <Button
                                style={{ backgroundColor: '#EB2026', border: 'none', borderRadius: '10px' }}
                                block
                                className="mt-3 py-2"
                              >
                                {this.state._loginMethod === 'phone' ? 'Send OTP' : 'Sign In'}
                              </Button>
                            </FormGroup>
                            <FormGroup>
                              <Button color="secondary" outline block type="button" onClick={this.openPasskeyPage}>
                                Sign in with passkey
                              </Button>
                            </FormGroup>
                          </>
                        )}
                        <LoginWithMS onExternalLoginComplete={this.showApplicationSelectionOrComplete} />
                      </Form>
                    )}
                  </Fragment>
                </CardBody>
              </Card>
            </LoadingOverlay>
          </Col>
        </Row>
        <Modal isOpen={this.state._showApplicationModal} toggle={this.handleApplicationModalClose} backdrop="static" keyboard={false}>
          <ModalHeader toggle={this.handleApplicationModalClose}>Select Application</ModalHeader>
          <ModalBody>
            <p>Please select the application you want to access:</p>
            <FormGroup>
              <Input
                type="select"
                value={this.state._selectedApplicationId}
                onChange={({ target }) => this.setState({ _selectedApplicationId: target.value })}
              >
                <option value="">Select an application...</option>
                {this.state._availableApplications.map(app => (
                  <option key={app.ApplicationGuid} value={app.ApplicationGuid}>
                    {app.ApplicationName}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleApplicationModalClose}>Cancel</Button>
            <Button color="primary" onClick={this.handleApplicationConfirm} disabled={!this.state._selectedApplicationId}>
              Continue
            </Button>
          </ModalFooter>
        </Modal>
      </Section>
    );
  }
}

export default withRouter(inject('applicationStore')(observer(Login)));